"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOmitFields = void 0;
var UserOmitFields = [
    '_id',
    'password',
    'verificationToken',
    'customerId',
    'referrer',
    'providers',
    'passwordToken',
    'gender',
    'paypal',
    'lastLoginAt',
    'jobTitle',
    'company',
    'industry',
    'notificationSettings',
];
exports.UserOmitFields = UserOmitFields;
